import React from 'react'
import { NavLink } from 'react-router'
import { getEnvColor, getEnvName, Mtds, TestTubeIcon } from 'prove-common'

type AppLogoProps = {
  appName: string
  hidden?: boolean
}

export const AppLogo = ({ appName, hidden }: AppLogoProps) => {
  const envName = getEnvName()
  const envColor = getEnvColor(envName)

  return (
    <Mtds.Logo
      as={NavLink}
      data-env={envName}
      data-color={envColor}
      hidden={hidden}
      to='/home'
    >
      <TestTubeIcon weight='fill' />
      {appName}
    </Mtds.Logo>
  )
}
